import UserTypes from './user.types'
import api from '../../api/index.api'
import { DEFAULT_PAGE_SIZE } from '../../utils/constant'

/**
 * Load users page. Compatible with PagedResourceList:
 *   onGetUsers(page, pageSize)
 *   onGetUsers(page, callback)
 * Optional filters as last object arg, or via options bag.
 *
 * @param {number} [page]
 * @param {number|Function|object} [second]
 * @param {Function|object} [third]
 * @param {object} [fourth]
 */
export const onGetUsers = (page = 0, second, third, fourth) => {
	return async dispatch => {
		let pageSize = DEFAULT_PAGE_SIZE
		let callback
		let filters = {}

		if (typeof second === 'function') {
			callback = second
		} else if (typeof second === 'number') {
			pageSize = second
			if (typeof third === 'function') {
				callback = third
			} else if (third && typeof third === 'object') {
				filters = third
				if (typeof fourth === 'function') {
					callback = fourth
				}
			}
		} else if (second && typeof second === 'object') {
			filters = second
			if (typeof third === 'function') {
				callback = third
			}
		}

		try {
			const result = await api.userApi.getAllUser(page, pageSize, filters)
			result.page = page + 1
			dispatch({
				type: UserTypes.GET_USERS,
				payload: result,
			})
			callback && callback(true, result)
		} catch (err) {
			callback && callback(false, err.message)
		}
	}
}

export const onDeleteUser = (id, fCallBack) => {
	return async dispatch => {
		try {
			const result = await api.userApi.deleteUser(id)
			dispatch({
				type: UserTypes.DELETE_USER,
				payload: result,
			})
			fCallBack && fCallBack(true, result)
		} catch (err) {
			fCallBack && fCallBack(false, err.message)
		}
	}
}
